// src/pages/personal/platforms/WhatsAppPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import WhatsAppSection from './WhatsAppSection/WhatsAppSection';

const WhatsAppPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <WhatsAppSection />
    </AdaptiveLayout>
  );
};

export default WhatsAppPage;